/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Entry type
 */
export type CreditTransactionsResponseItemEntryType = typeof CreditTransactionsResponseItemEntryType[keyof typeof CreditTransactionsResponseItemEntryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditTransactionsResponseItemEntryType = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
} as const;
